import { Section, eType, SectionInitData } from "./Section";
import { GameWorld, eGameObject as eWorldObject } from "../GameWorld";
import { ParcelManager } from "../../Parcel/ParcelManager";



/**
 * Horni sekce s dodavkou
 */
export class VanTop extends Section {
    private _vanEntity: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("vanTop", eType.topVan, false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(z: number, initData?: SectionInitData): Section {
        super.activate(z, initData);

        // Pridat odberne misto do seznamu odbernych mist
        ParcelManager.instance.addDeliveryPoint(this._vanEntity, z + 1.8, -1);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let world = GameWorld.instance;

        // Zem
        let e = world.getObjectNewEntity(eWorldObject.ground_0);
        e.setEulerAngles(0, 180, 0);
        e.setPosition(0, 0, 0);
        e.reparent(this._root);

        // Zed
        e = world.getObjectNewEntity(eWorldObject.wall);
        e.setPosition(0, 0, -1.25);
        e.reparent(this._root);

        // Budova L
        e = world.getObjectNewEntity(eWorldObject.building_0);
        e.setLocalPosition(-2, 0, -0.1);
        e.reparent(this._root);

        // Budova R
        e = world.getObjectNewEntity(eWorldObject.building_1);
        e.setEulerAngles(0, 180, 0);
        e.setLocalPosition(2, 0, -0.1);
        e.reparent(this._root);

        // Dodavka
        e = world.getObjectNewEntity(eWorldObject.van);
        e.setEulerAngles(0, 180, 0);
        e.setLocalPosition(0, 0, -0.2);
        e.setLocalScale(1, 1, 1);
        e.reparent(this._root);
        this._vanEntity = e;

        // Palety
        e = world.getObjectNewEntity(eWorldObject.pallet);
        e.setEulerAngles(60, 90, 0);
        e.setLocalPosition(-0.827, 0.285, 0.1);
        e.reparent(this._root);

        // Krabice
        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(-2.4, 0.035, 0.85);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(-2, 0.035, 0.85);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 45, 0);
        e.setLocalPosition(-2.2, 0.315, 0.85);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(1.2, 0.035, 0.85);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(1.55, 0.035, 0.85);
        e.reparent(this._root);
    }
}